import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';

import { ServiceGroup } from '@/types/serviceGroup';
import { pages } from '@/settings/pages';
import { serviceGroupsApi } from '@/services/api';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import i18n from '@/settings/i18n';
import { sentryReportError } from '@/utils/sentryReportError';

import { ServiceDetail } from '../Presentation';

export const ViewContainer: React.FC = () => {
  const [service, setService] = useState<ServiceGroup>();

  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { flashError } = useFlashMessenger();

  useEffect(() => {
    const fetchService = async () => {
      if (!id) {
        navigate(pages.top);
        return;
      }
      try {
        const serviceId = Number(id);
        const serviceGroup = await serviceGroupsApi.getDetail(serviceId, {});
        if (!serviceGroup) {
          navigate(pages.top);
          return;
        }
        setService(serviceGroup);
      } catch (error) {
        if (axios.isAxiosError(error) && error.response !== undefined) {
          if (error.response.status === 401) {
            return;
          } else {
            sentryReportError(error);

            flashError(i18n.t('ui.error.unexpected'));
          }
        } else {
          sentryReportError(error);

          flashError(i18n.t('ui.error.unexpected'));
        }
      }
    };
    fetchService();
  }, [id, navigate, flashError]);

  return <ServiceDetail service={service} />;
};
